/** Get the Google OAuth URL for the UI to redirect to for login. */
export const sessionGoogleAuthSpec = {
    uri: '/t/[tenant]/session/google-auth',
    method: 'GET',
    allowAnonymous: true,
};
